import { useSelectedMember } from '#components/member-selector-context/member-selector-context.tsx';
import { useWalletParams } from '#hooks/use-wallet-params.hook.ts';
import { useWalletCardQuery } from '#pages/wallet-detail/hooks/use-wallet-card-query.hook.ts';

export function useWalletCard(cardHtml?: string) {
  const { userId, benefitId } = useWalletParams();
  const [memberId] = useSelectedMember();

  // if the cardHtml prop is present, we'll render that;
  // if not, we get the HTML from the query cache.
  const { data: walletCard, isInitialLoading: isLoading } = useWalletCardQuery(
    userId,
    benefitId,
    memberId?.id,
    {
      enabled: !cardHtml,
    },
  );

  let cardFront = walletCard?.front;

  // if cardHtml is provided, use that instead
  if (cardHtml) {
    cardFront = { src: cardHtml, type: 'html', description: '' };
  }

  const isImageCard =
    walletCard?.front.type === 'url' || walletCard?.front.type === 'base64';

  const cardFaces = [cardFront!, walletCard?.back!].filter((face) => !!face);

  return {
    isLoading,
    isImageCard,
    cardFaces,
  };
}
